//button events are generated automatically from translations
export enum MIXPANEL_EVENTS {
  LEARN_MORE = "Learn More",
  TRUST_SCORE = "Trust Score",
  OPEN_HELPER_CENTER = "Open Helper Center",
  DASHBOARD = "Dashboard",
  USER_ENTER_PROMOTION = "User Enter Promotion",
  USER_CLICK_MINT_SCORE_NETWORK = "User Click Mint Score Network",
}
